<template>
  <div class="min-h-screen bg-slate-50">
    <header class="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-16">
      <div class="container mx-auto px-4 text-center">
        <!-- Logo/Brand element -->
        <div class="flex justify-center mb-6">
          <router-link to="/" class="transition-transform duration-200 hover:scale-105">
            <img src="@/assets/images/logo-compact.svg" alt="Hardware Pulse" class="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity duration-200" />
          </router-link>
        </div>
        <h1 class="heading-xl">Terms and Conditions</h1>
        <p class="text-slate-300 mt-4">Our terms of service and usage guidelines</p>
      </div>
    </header>

    <main class="container mx-auto px-4 py-12 max-w-4xl">
      <div class="bg-white rounded-xl shadow-lg p-8 lg:p-12 border border-slate-200">
        <div
          class="prose prose-slate max-w-none prose-headings:text-slate-900 prose-headings:font-bold prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4 prose-p:text-slate-700 prose-p:leading-relaxed prose-a:text-blue-600 prose-a:no-underline hover:prose-a:underline"
        >
          <section>
            <h2>Introduction</h2>
            <p>
              Welcome to Hardware Pulse. By accessing or using our website, you agree to be bound by these Terms and Conditions, which govern your use of our
              site. Please read them carefully.
            </p>
          </section>

          <section>
            <h2>Affiliate Links</h2>
            <p>
              Some of the links on our website are affiliate links, which means that if you click on one of the links and make a purchase, we may receive a
              small commission at no additional cost to you. These commissions help support the continued operation of our site.
            </p>
          </section>

          <section>
            <h2>On-Screen Advertisements</h2>
            <p>
              Our website may display advertisements, including banners and other promotional content. These ads are provided by third-party advertisers and do
              not constitute an endorsement by Hardware Pulse of any products or services advertised.
            </p>
          </section>

          <section>
            <h2>Email Newsletter Collection</h2>
            <p>
              We collect email addresses when you subscribe to our newsletter. Your email address will be used solely for sending you updates, news, and
              promotional material related to Hardware Pulse. You can unsubscribe at any time by following the instructions in our emails.
            </p>
          </section>

          <section>
            <h2>Content and Intellectual Property</h2>
            <p>
              All content on this website, including text, images, logos, and data compilations, is the property of Hardware Pulse or its content suppliers and
              is protected by copyright and other intellectual property laws. You may not reproduce or distribute any content without prior written permission.
            </p>
          </section>

          <section>
            <h2>User Responsibilities</h2>
            <p>
              You agree to use our website responsibly and in compliance with all applicable laws. You shall not engage in any activity that could harm the
              website, its users, or its reputation.
            </p>
          </section>

          <section>
            <h2>Disclaimers and Limitation of Liability</h2>
            <p>
              Hardware Pulse provides information on an "as is" basis. We make no warranties, expressed or implied, regarding the accuracy, reliability, or
              completeness of the content. We will not be held liable for any damages arising from the use of our website, including those caused by affiliate
              links, advertisements, or newsletter subscriptions.
            </p>
          </section>

          <section>
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any time. Any changes will be posted on this page, and your continued use of the
              website indicates your acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at
              <a href="mailto:support@hardwarepulse.com">support@hardwarepulse.com</a>.
            </p>
          </section>
        </div>
      </div>
    </main>

    <footer class="bg-slate-800 text-slate-300 py-8">
      <div class="container mx-auto px-4 text-center">
        <p>&copy; 2025 Hardware Pulse. All Rights Reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'TermsAndConditions',
  };
</script>

<style scoped>
  /* Tailwind CSS handles all styling with @tailwindcss/typography for prose content */
</style>
